<template>
		
		<!-- 发布需求窗口 -->
		<div v-show="publishbox">
			<div style="position: fixed;left:0;top:0;width: 100vw;height:100vh;background-color: rgba(0, 0, 0, 0.5);display: flex;justify-content: center;z-index: 10;">
				<div style="margin-top: 6rem;background-color: #fff;border-radius: 1rem;padding: 2rem;display: flex;flex-direction: column;width: 35rem;align-items: center;position: relative;
					height: fit-content;"
					class="box1">
					<!-- 关闭按钮 -->
					<img src="../../assets/imgs/login/close.svg" style="width: 1rem;height: 1rem;position: absolute;right: 1rem;top: 1rem;cursor: pointer;" @click="publishbox=false">
					
					<div style="font-size: 1.2rem;font-weight: 500;margin-bottom: 1rem;"><span>{{type==1?'Publish':'Edit'}}</span> demands</div>
					
					<div style="height: 26rem;overflow-y: scroll;width: 100%;" class="box2">
						
						<!-- 内容 -->
						<div style="width: 100%;position: relative;" class="publish-input">
							
							<!-- 文本域 -->
							<textarea cols="30" rows="10" style="min-height: 3rem;cursor: initial;width: 100%;border: none;max-height: 8rem;" v-model="content"
									:style="{height: img_list.length!=0?'13rem':'10rem'}"></textarea>
							
							<!-- 图片上传 -->
							<div style="display: flex;width: 94%;flex-direction: column;">
								<div style="display: flex;flex-wrap: wrap;">
									<div v-for="(item,index) in img_list" :key="index" style="position: relative;">
										<div @click="del(index)" style="position: absolute;right: 0.5rem;top: -0.5rem;cursor: pointer;">
											<img src="../../assets/imgs/close-gray.png" style="width: 1rem;height: 1rem">
										</div>
										<img :src="item"  style="width: 4rem;height: 4rem;margin-right: 0.5rem;margin-bottom: 0.5rem;" @click="largeimg(img_list, index)"/>
									</div>
								</div>
								
								<div style="display: flex;align-items: center;justify-content: center;">
									 <div style="flex: 1;display: flex;align-items: center;">
										<div style="display: flex;">
											<form action="" enctype="multipart/form-data">
												<input ref="fileInput" type="file"  multiple="multiple"  accept="image/*" @change="getImg"  id="imgfile"/> 
											</form>
											<div @click="clickimgFile()"><img src="../../assets/imgs/upload.svg" style="width: 2rem;height: 2rem;margin-right: 1rem;cursor: pointer;"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						
						<!-- 标签 -->
						<!-- <div class="publish-input">Select tags</div> -->
						
						<div style="position: relative;" class="publish-input">
							<div style="display: flex;align-items: center;cursor: pointer;" 
								@click="tagbox=!tagbox"><span v-if="!tag" style="color: #ccc;">Choose category</span>{{tag}}</div>
							<div style="" class="sel-box" v-show="tagbox">
								<div v-for="(item, index) in tagdata" :key="index" class="sel-box-list" @click="changetag(item)"><span style="flex: 1;">{{item.title}}</span></div>
							</div>
						</div>
						
						<!-- 时间 -->
						<!-- <div class="publish-input">Deadline</div> -->
						<DatePicker
							class="publish-input"
							v-model="date"
							:local="local"
							placeholder="Deadline"
							format="YYYY-MM-DD"/>
						
						<!-- 附件 -->
						<div class="publish-input" @click="clickattrachmentfile()" :class="{'color-gray':!attachmentname}">
							<span v-show="uploadname=='file uploading...'"><img src="../../assets/imgs/demand/loading.gif" style="width: 1rem;height: 1rem;"></span>
							{{attachmentname?attachmentname:uploadname}}
						</div>
						<form action="" enctype="multipart/form-data">
							<input ref="attachmentfile" type="file"  multiple="multiple" @change="getattachment"  id="attachmentfile"/> 
						</form>
						
						<!-- 邮箱 -->
						<div class="publish-input">
							<input type="text" v-model="email" style="border: none;background-color: transparent;" placeholder="Email">
						</div>
					</div>
					
					<!-- 提交 -->
					<div style="display: flex;align-items: center;justify-content: space-between;width: 100%;margin-top: 1rem;">
						<div class="btn-normal" style="width: 49%;" @click="publishbox=false">Cancel</div>
						<div class="btn-cyan-liner" @click="saveinfo()" style="flex: 1;width: 49%;padding: 0.5rem 1.2rem;align-items: center;justify-content: center;display: flex;cursor: pointer;" >
							Send
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
		import DatePicker from 'vue-datepicker-local'
		export default {
			data() {
				return {
					islogin:false,
					isMobile:false,
					publishbox:false,
					attachmentname:'',
					
					tagbox:false,
					tagdata:[],
					tag:'',
					tagid: '',
					email:'',
					
					img_list:[],
					attachmenturl: '',
					
					date: '', // 默认选择当前日期
					local: { // 定制化日期选择的格式内容
						dow: 1, // Monday is the first day of the week
						yearSuffix: '', // format of head
						monthsHead: '1_2_3_4_5_6_7_8_9_10_11_12'.split('_'), // months of head
						months: '1_2_3_4_5_6_7_8_9_10_11_12'.split('_'), // months of panel
						weeks: 'Mon_Tue_Wed_Thu_Fri_Sat_Sun'.split('_') // weeks
					},
					
					content:'',
					
					type:null,
					data:null,
					uploadname:'Upload file'
				}
			},
			props:{
			},
			components: {
				DatePicker
			},
			watch: {
				date (to, from) {
					console.log('to:', to)
					if (to === '') {
						// this.checkFields('date')
					} else {
						// this.checkFocus('date')
					}
				}
			},
			filters: {
			},
			methods: {
				saveinfo(){
					let url
					const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
					if(this.type==1){
						url = '/gci/demand/add'
					}
					if(this.type==2){
						url = '/gci/demand/'+this.data.id+'/edit'
					}
					let params = {
					  content: this.content,
					  expireTime:  Math.round(this.date.valueOf()/1000),
					  contact: this.email,
					  images: this.img_list,
					  attachment: this.attachmenturl,
					  classifyId: this.tagid
					}
					if(!params.content){
						this.$bus.$emit('message',{
							type:1,
							msg: 'content is empty'
						})
					}else if(!params.classifyId){
						this.$bus.$emit('message',{
							type:1,
							msg: 'please choose classification'
						})
					}else if(!params.expireTime){
						this.$bus.$emit('message',{
							type:1,
							msg: 'deadline is empty'
						})
					}else if(!params.contact){
						this.$bus.$emit('message',{
							type:1,
							msg: 'email is empty'
						})
					}else if (!mailReg.test(params.contact)) {
						this.$bus.$emit('message',{
							type:1,
							msg: 'email is not promise'
						})
					}else{
						console.info(params)
						this.request({
							method: 'post',
							url: url,
							data:params
						}).then(res => {
							if(res.status==0){
								if(this.type == 1){
									this.$bus.$emit('message',{
										type:2,
										msg: 'Reviewing, check in Personal Center - My Demands'
									})
								}
								if(this.type == 2){
									this.$bus.$emit('message',{
										type:2,
										msg: 'Reviewing, check in Personal Center - My Demands'
									})
								}
								this.publishbox = false
							}else{
								this.$bus.$emit('message',{
									type:3,
									msg: res.msg
								})
							}
						}).catch(error => {
							console.error(error.response)
						})
					}
					
				},
				changetag(obj){
					this.tag = obj.title
					this.tagid = obj.id
					this.tagbox = false
				},
				gettagdata(){
					this.request({
						method: 'get',
						url: '/gci/demand/classify',
					}).then(res => {
						this.tagdata = res.data.items
					}).catch(error => {
						console.error(error.response)
					})
				},
				
				largeimg(imgs, index){
					this.$bus.$emit('largeimg', {show:true, imgs:imgs, index:index})
				},
				getattachment(e){
					this.uploadname = 'file uploading...'
					var file = e.target.files;//这个就是选中文件信息
					// console.info(file)
					let formdata = new FormData()
					Array.from(e.target.files).map(item => {
					 console.log(item)
					 formdata.append("file", item)  //将每一个文件图片都加进formdata
				   })
					this.request.post('/upload', formdata).then(res => { 
						console.log(res) 
						if(res.status==0){
							this.$bus.$emit('message',{
								type:2,
								msg: 'upload success'
							})
							this.attachmentname = file[0].name
							this.attachmenturl = res.data.url;
						}else{
							this.$bus.$emit('message',{
								type:3,
								msg: res.msg
							})
						}
						this.uploadname = 'Upload file'
					})
				},
				clickimgFile() {
					// const input = document.querySelector('#file')
					// input.click()
					this.$refs.fileInput.dispatchEvent(new MouseEvent('click'))
				},
				clickattrachmentfile(){
					this.$refs.attachmentfile.dispatchEvent(new MouseEvent('click'))
				},
				getImg(e){
					var file = e.target.files;//这个就是选中文件信息
					let formdata = new FormData()
					Array.from(e.target.files).map(item => {
					 console.log(item)
					 formdata.append("file", item)  //将每一个文件图片都加进formdata
				   })
					this.request.post('/upload', formdata).then(res => { 
						console.log(res) 
						if(res.status==0){
							this.$bus.$emit('message',{
								type:2,
								msg: 'upload success'
							})
						}
						this.img_list.push(res.data.url);
					})
				},
				del(index){
					this.img_list.splice(index,1)
				},
				getupdatedata(){
					// 编辑数据填充
					console.info(this.data)
					this.content = this.data.content
					this.email = this.data.contact
					this.tagid = this.data.classify.id
					this.tag = this.data.classify.title
					this.date = new Date(this.data.expireTime*1000)
					this.img_list = this.data.images
					
					if(this.data.attachment.length>0){
						this.attachmenturl = this.data.attachment[0]
						let arr = this.data.attachment[0].split('/')
						this.attachmentname = arr[arr.length-1]
					}
					this.publishbox = true
				}
			},
			created() {
			},
			mounted() {
				localStorage.getItem('isMobile') == 'null'?this.isMobile = false:this.isMobile = true
				let token = localStorage.getItem('token')
				if(token){
					this.islogin = true
				}
				this.gettagdata()
				
				this.$bus.$on("publishbox",value=>{
					this.type = value.type
					if(this.type==1){
						this.content = ''
						this.email = ''
						this.tagid = ''
						this.tag = ''
						this.date = ''
						this.img_list =[]
						this.attachmenturl = ''
						this.attachmentname = ''
						
						this.publishbox = value.show
					}else{
						this.data = value.data
						this.getupdatedata()
					}
				});
			}
		}
</script>

<style scoped lang="scss">
	
	#imgfile {
		display: none;
	}
	
	#attachmentfile{
		display: none;
	}
	
	.publish-input{
		background-color: #fff;border:1px solid #D1D1D1;width: 100%;padding: 0.5rem;margin-bottom: 1rem;cursor: pointer;
	}
	
	// 下拉
	.sel-box{
		width: 100%;max-height: 20rem;position: absolute;background-color: #fff;border: 1px solid #000;left: 0;top: 2.5rem;overflow: scroll;z-index: 20;
		.sel-box-list{
			display: flex;
			padding: 0 1rem;
		}
	}
	.sel-box-list:hover{
		background-color: #31ffda;
	}
	.sel-box::-webkit-scrollbar {display:none}
	
	
	
	.login-button{
		border-radius: 0.2rem;color: #333;font-size: 1rem;font-weight: bold;background: #f3f3f3;
		width: 100%;height: 2.5rem;display: flex;align-items: center;justify-content: center;
	}
	.login-btn-active{
		background:linear-gradient(90deg, #4EDFD2 0%, #92FBF2 100%);
		cursor: pointer;
	}
	
	.color-gray{
		color: #C3C3C3;
	}
	
	// 日期时间选择器
	/deep/ .datepicker>input.focus{
		border-color: transparent;
		box-shadow: none;
	}
	/deep/ .datepicker>input{
		border: 1px solid transparent;
		padding: 0;
		height: 100%;
	}
	/deep/ .datepicker>input::placeholder{
		color: #C3C3C3;
	}
	
	// 输入框
	input::placeholder{
		color: #C3C3C3;
	}
	textarea::-webkit-scrollbar{display: none;}
	.box2::-webkit-scrollbar{display: none;}
	@media (max-width:767px) {
		.box1{
			width: 22rem !important;
			padding: 1rem !important;
		}
	}
</style>